if (!customElements.get('gless-slideshow')) {
  customElements.define(
    'gless-slideshow',
    class GlessSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.current = 0;
        this.delay = Number(this.dataset.delay) || 6000;

        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.show(Number(slide.dataset.index), false);
          this.stop();
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index, restart = true) {
        if (this.slides.length < 2) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        const counter = this.querySelector('[data-current]');
        if (counter) counter.textContent = String(this.current + 1).padStart(2, '0');
        if (restart) {
          this.stop();
          this.start();
        }
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.current + 1, false), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = undefined;
      }
    },
  );
}
